import * as React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import {Divider, CardContent} from '@mui/material';
import {Button} from '@material-ui/core';
import CommentSave from './CommentSave';

export default function BasicTable(props) {

  const childRefComments = React.useRef();
  const [rows, setRows] = React.useState([]);

  React.useEffect(() => {
    setRows(props.rows);
  }, [props.rows]);

  function add() {
    childRefComments.current.handleClickOpen();
  }

  function updatedList(list){
    setRows(list);
    props.comments(list);
  }

  return (<>
        <div style={{textAlign:'center'}}>
        <Button onClick={() => {add()}} style={{textTransform:'none',maxHeight:25}} size="small" variant="outlined" >Add Comment</Button>
        </div>
        {props.commentLinearProgress?<LinearProgress />:null}
        {(rows && rows.length>0)?rows.map((row,index)=>(  
          <React.Fragment key={'ct'+index}>          
              <CardContent>
                {row.comment}<br/>
                <small>Created By: {row.createdAlias} {row.createdDateTime}</small>
                <Divider />
              </CardContent>
          </React.Fragment>
          )):<div className='nrfbox' >No comment found</div>}

    <CommentSave relatedTo={props.relatedTo} relatedToId={props.relatedToId} showToCustomer={props.showToCustomer} updatedList={updatedList} userObj={props.userObj} ref={childRefComments} />

  </>);
}
